import { TableId } from '@/modules/common/enums/table-id.enum.ts';

export const FOLDER_TABLE_ID = 0;

export const FAVORITE_EXTRA_TABLE_IDS: Partial<Record<TableId, TableId[]>> = {
  [TableId.Documents]: [TableId.files],
};

export const FAVORITE_NAME_MAX_LENGTH = 255;

export const FAVORITE_FOLDER_ID_ATTEMPTS = 3;
